import { connect } from 'react-redux';
import Modal from 'comp/modals/submissions';
import * as selectors from 'selectors';
import { cache } from 'utils';

const mapToProps = state => {
  const conv_id = state.ui.selected_group;
  const task_id = state.ui.selected_task;
  return {
    members: selectors.getSelectedGroupMembers(),
    submissions: state.group[conv_id].submissions || cache.empty_obj,
    conv_id,
    task_id
  };
};

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/Submissions.js